import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '../Button/Button.esm.js';
import '@panwds/icons';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';
import { Popover } from '../Popover/Popover.esm.js';
import '../../utils/constants.esm.js';
import '@headlessui/react';
import { DateRangePicker } from './DateRangePicker.esm.js';

function defaultFormatDateRange(dateRange, intl) {
    if (!dateRange) {
        return intl.formatMessage({ id: "bKPSni", defaultMessage: [{ type: 0, value: "Select a date range" }] });
    }
    return intl.formatMessage({ id: "9BLmzs", defaultMessage: [{ type: 0, value: "From " }, { type: 3, value: "start", style: { type: 1, pattern: "MMddyyyy", parsedOptions: { month: "2-digit", day: "2-digit", year: "numeric" } } }, { type: 0, value: " to " }, { type: 3, value: "end", style: { type: 1, pattern: "MMddyyyy", parsedOptions: { month: "2-digit", day: "2-digit", year: "numeric" } } }] }, { start: dateRange.start, end: dateRange.end });
}
/**
 * Select a date range.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { DateRangePickerDialog } from "@panwds/react-ui";
 * ```
 */
const DateRangePickerDialog = ({ button, dataMetrics, dataTestId, formatDateRange = defaultFormatDateRange, fullWidth = false, initialActiveDate, label, defaultPlacement = "bottom-start", max, min, onApply, dateRange, showLabel, weekStartsOn, disabled = false, addClassName, }) => {
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(Popover, { dataMetrics: dataMetrics, dataTestId: dataTestId || "date-range-picker-dialog", button: button || (React.createElement(Button, { fullWidth: fullWidth, isMenu: true, disabled: disabled }, formatDateRange(dateRange, intl))), defaultPlacement: defaultPlacement, label: label !== null && label !== void 0 ? label : intl.formatMessage({ id: "XSDZbV", defaultMessage: [{ type: 0, value: "Search range" }] }), showLabel: showLabel, isOpen: isOpen, onIsOpenChange: setIsOpen, addClassName: addClassName },
        React.createElement(DateRangePicker, { initialActiveDate: initialActiveDate, initialDateRange: dateRange, max: max, min: min, onApply: (nextDateRange) => {
                onApply(nextDateRange);
                setIsOpen(false);
            }, onCancel: () => setIsOpen(false), weekStartsOn: weekStartsOn, disabled: disabled })));
};

export { DateRangePickerDialog };
//# sourceMappingURL=DateRangePickerDialog.esm.js.map
